import Dashboard from "../../../layouts/SeekerShell.vue";
import AgencyDashboard from "../views/agency-dashboard.vue";
import SearchAgency from "../views/search-agency.vue";
import ManageAgencyRequests from "../views/manage-agency-requests.vue";
import ConnectedAgenciesCaseWorkers from "../views/connected-agencies-caseworkers.vue";

export default [
  {
    path: "/",
    name: "agencyModule",
    component: Dashboard,
    children: [
      {
        path: "/agency-dashboard",
        name: "agency-dashboard",
        component: AgencyDashboard,
        title: "Career Center Dashboard"
      },
      {
        path: "/search-agency",
        name: "search-agency",
        component: SearchAgency,
        title: "Search Career Center"
      },
      {
        path: "/manage-agency-requests",
        name: "manage-agency-requests",
        component: ManageAgencyRequests,
        title: "Manage Requests"
      },
      {
        path: "/connected-agencies-caseworkers",
        name: "connected-agencies-caseworkers",
        component: ConnectedAgenciesCaseWorkers,
        title: "Manage Requests"
      }
    ]
  }
];
